<template>
    <div class="about" style="padding: 20px">
        <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:divider>
                <v-icon>mdi-forward</v-icon>
            </template>
        </v-breadcrumbs>
        <h1>Modify House</h1>
        <v-form
                enctype="multipart/form-data"
                ref="form"
                v-model="valid"        >
            <v-card outlined :loading="loading.general">
                &nbsp;
                <v-expansion-panels focusable v-model="panel">
                    <!--general-->
                    <v-expansion-panel>
                        <v-expansion-panel-header>General</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row>
                                <v-col
                                        cols="12"
                                        md="4"
                                        sm="6"
                                >
                                    <v-text-field
                                            v-model="dados.title"
                                            :counter="200"
                                            maxlength="200"
                                            label="Meta Title"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                        cols="12"
                                        md="4"
                                        sm="6"
                                >
                                    <v-text-field
                                            v-model="dados.description"
                                            :counter="200"
                                            maxlength="200"
                                            label="Meta Description"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                        cols="12"
                                        md="4"
                                        sm="6"
                                >
                                    <v-text-field
                                            v-model="dados.keywords"
                                            :counter="200"
                                            maxlength="200"
                                            label="Meta Keywords"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                        cols="12"
                                        md="4"
                                        sm="6"
                                >
                                    <v-text-field
                                            v-model="dados.url"
                                            :counter="200"
                                            maxlength="200"
                                            label="URL"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                        cols="12"
                                        md="4"
                                        sm="6"
                                >
                                    <v-select
                                            v-model="dados.condominium"
                                            label="Community"
                                            :items="condominiums"
                                            item-text="name"
                                            item-value="id"
                                            :loading="loading.condominiums"
                                    >
                                    </v-select>
                                </v-col>
                                <v-col
                                        cols="12"
                                        md="4"
                                        sm="6"

                                >
                                    <v-text-field
                                            ref="price"
                                            v-model.lazy="dados.price"
                                            v-money="money"
                                            maxlength="200"
                                            :rules="priceRules"
                                            label="Price"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                        cols="12"
                                        md="2"
                                        sm="6"
                                >
                                    <v-text-field
                                            v-model="dados.guests"
                                            maxlength="200"
                                            label="Guests"
                                            v-mask="['###']"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                        cols="12"
                                        md="2"
                                        sm="6"
                                >
                                    <v-text-field
                                            v-model="dados.rooms"
                                            maxlength="200"
                                            label="Rooms"
                                            v-mask="['###']"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                        cols="12"
                                        md="2"
                                        sm="6"
                                >
                                    <v-text-field
                                            v-model="dados.bed"
                                            maxlength="200"
                                            label="Beds"
                                            v-mask="['###']"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                        cols="12"
                                        md="2"
                                        sm="6"
                                >
                                    <v-text-field
                                            v-model="dados.bath"
                                            maxlength="200"
                                            label="bathroom"
                                            v-mask="['###']"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                        cols="12"
                                        md="4"
                                        sm="6"

                                >
                                    <v-switch v-model="dados.status" class="ma-4" label="Active"></v-switch>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!--bookings-->
                    <v-expansion-panel>
                        <v-expansion-panel-header>Bookings</v-expansion-panel-header>
                        <v-expansion-panel-content style="max-height: 250px; overflow: auto">
                            <v-row>
                                <v-col cols="6">
                                    <v-dialog
                                            ref="dialog"
                                            v-model="modal"
                                            :return-value.sync="dates"
                                            persistent
                                            width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                    v-model="dateRangeText"
                                                    label="Select the date"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                v-model="dates"
                                                full-width
                                                range
                                                scrollable
                                                :min="dataAtual"
                                                max="2025-12-31"
                                                :allowed-dates="allowedDates"
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                    text
                                                    color="primary"
                                                    @click="modal = false"
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn
                                                    text
                                                    color="primary"
                                                    @click="saveDate"
                                            >
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>
                                <v-col cols="6">
                                    <v-list dense>
                                        <v-list-item v-for="(item,index) in dados.bookings" :key="index">
                                            <v-list-item-avatar>
                                                <v-icon
                                                        class="grey lighten-1"
                                                        dark
                                                >
                                                    mdi-calendar
                                                </v-icon>
                                            </v-list-item-avatar>
                                            {{item.init}} ~ {{item.end}}
                                            <v-list-item-content>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-btn icon @click="deleteDate(index)">
                                                    <v-icon color="grey lighten-1">mdi-delete</v-icon>
                                                </v-btn>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!--images-->
                    <v-expansion-panel>
                        <v-expansion-panel-header>Images</v-expansion-panel-header>
                        <v-expansion-panel-content style="max-height: 500px; overflow: auto">
                            <v-row>
                                <!-- images -->
                                <v-col
                                        cols="12"
                                        md="12"
                                        sm="12"
                                        xs="12"

                                >
                                    <v-file-input
                                            multiple
                                            prepend-icon="mdi-camera"
                                            show-size
                                            counter
                                            small-chips
                                            v-model="file"
                                            label="Images (800x600)"
                                            accept="image/*"
                                            @change="onFileChange"
                                    ></v-file-input>
                                    <v-row dense>
                                        <v-col
                                                v-for="(image,index) in imageUrl"
                                                :key="index"
                                                cols="6"
                                                md="2"
                                                sm="3"
                                                xs="6"
                                        >
                                            <v-card>
                                                <v-img
                                                        :src="image.src"
                                                        class="white--text align-end"
                                                        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                                >
                                                    <v-card-title v-text="image.ordem"></v-card-title>
                                                </v-img>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-text-field
                                                            v-model="image.ordem"
                                                            label="Sort"
                                                            @change="sortImage(index)"
                                                    ></v-text-field>
                                                    <v-btn icon @click="deleteImage(index)">
                                                        <v-icon>mdi-delete</v-icon>
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!--Descriptions-->
                    <v-expansion-panel>
                        <v-expansion-panel-header>Descriptions</v-expansion-panel-header>
                        <v-expansion-panel-content style="max-height: 500px; overflow: auto">
                            <v-row>
                                <v-tabs
                                        :grow="true"
                                        background-color="indigo"
                                        dark
                                >
                                    <v-tab @click="language='en'">English</v-tab>
                                    <v-tab @click="language='pt'">Portuguese</v-tab>
                                    <v-tab @click="language='es'">Spanish</v-tab>
                                </v-tabs>
                                <v-col v-if="language=='en'"
                                        cols="12"
                                >
                                    <v-text-field
                                            v-model="dados.name_en"
                                            :counter="200"
                                            maxlength="200"
                                            label="Name"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                        cols="12"
                                        v-if="language=='en'"
                                >
                                    <v-textarea
                                            outlined
                                            maxlength="250"
                                            :counter="250"
                                            label="Short Description"
                                            v-model="dados.short_description_en"
                                    ></v-textarea>
                                </v-col>
                                <v-col
                                        cols="12"
                                        v-if="language=='en'"
                                >
                                    <span>Description</span>
                                    <vue-editor v-model="dados.en"></vue-editor>
                                </v-col>
                                <!-- PT -->
                                <v-col v-if="language=='pt'"
                                       cols="12"
                                >
                                    <v-text-field
                                            v-model="dados.name_pt"
                                            :counter="200"
                                            maxlength="200"
                                            label="Name"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                        cols="12"
                                        v-if="language=='pt'"
                                >
                                    <v-textarea
                                            outlined
                                            :counter="250"
                                            maxlength="250"
                                            label="Short Description"
                                            v-model="dados.short_description_pt"
                                    ></v-textarea>
                                </v-col>
                                <v-col
                                        cols="12"
                                        v-if="language=='pt'"
                                >
                                    <span>Description</span>
                                    <vue-editor v-model="dados.pt"></vue-editor>
                                </v-col>
                                <!-- ES -->
                                <v-col v-if="language=='es'"
                                       cols="12"
                                >
                                    <v-text-field
                                            v-model="dados.name_es"
                                            :counter="200"
                                            maxlength="200"
                                            label="Name"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                        cols="12"
                                        v-if="language=='es'"
                                >
                                    <v-textarea
                                            outlined
                                            maxlength="250"
                                            :counter="250"
                                            label="Short Description"
                                            v-model="dados.short_description_es"
                                    ></v-textarea>
                                </v-col>
                                <v-col
                                        cols="12"
                                        v-if="language=='es'"
                                >
                                    <span>Description</span>
                                    <vue-editor v-model="dados.es"></vue-editor>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!--bullets-->
                    <v-expansion-panel>
                        <v-expansion-panel-header>Bullets</v-expansion-panel-header>
                        <v-expansion-panel-content style="max-height: 500px; overflow: auto">
                            <v-row>
                                <v-tabs
                                        :grow="true"
                                        background-color="indigo"
                                        dark
                                >
                                    <v-tab @click="language='en'">English</v-tab>
                                    <v-tab @click="language='pt'">Portuguese</v-tab>
                                    <v-tab @click="language='es'">Spanish</v-tab>
                                </v-tabs>
                                <v-col v-if="language=='en'"
                                       cols="12"
                                >
                                    <v-row v-for="(bullets,index) in dados.bullets_en" :key="index+'bullets'">
                                        <v-col cols="4" md="1">
                                            <v-select :items="items"
                                                      v-model="bullets.icon"
                                                      label="Icon">
                                                <template v-slot:selection="data">
                                                    <v-icon>{{data.item}}</v-icon>
                                                </template>
                                                <template slot="item" slot-scope="data">
                                                    <v-icon>{{data.item}}</v-icon>
                                                </template>
                                            </v-select>
                                        </v-col>
                                        <v-col cols="4" md="4">
                                            <v-text-field
                                                    v-model="bullets.title"
                                                    :counter="50"
                                                    maxlength="50"
                                                    label="Title"
                                                    required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4" md="7">
                                            <v-text-field
                                                    v-model="bullets.description"
                                                    :counter="100"
                                                    maxlength="100"
                                                    label="Description"
                                                    required
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col v-if="language=='pt'"
                                       cols="12"
                                >
                                    <v-row v-for="(bullets,index) in dados.bullets_pt" :key="index+'bullets'">
                                        <v-col cols="4" md="1">
                                            <v-select :items="items"
                                                      v-model="bullets.icon"
                                                      label="Icon">
                                                <template v-slot:selection="data">
                                                    <v-icon>{{data.item}}</v-icon>
                                                </template>
                                                <template slot="item" slot-scope="data">
                                                    <v-icon>{{data.item}}</v-icon>
                                                </template>
                                            </v-select>
                                        </v-col>
                                        <v-col cols="4" md="4">
                                            <v-text-field
                                                    v-model="bullets.title"
                                                    :counter="50"
                                                    maxlength="50"
                                                    label="Title"
                                                    required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4" md="7">
                                            <v-text-field
                                                    v-model="bullets.description"
                                                    :counter="100"
                                                    maxlength="100"
                                                    label="Description"
                                                    required
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col v-if="language=='es'"
                                       cols="12"
                                >
                                    <v-row v-for="(bullets,index) in dados.bullets_es" :key="index+'bullets'">
                                        <v-col cols="4" md="1">
                                            <v-select :items="items"
                                                      v-model="bullets.icon"
                                                      label="Icon">
                                                <template v-slot:selection="data">
                                                    <v-icon>{{data.item}}</v-icon>
                                                </template>
                                                <template slot="item" slot-scope="data">
                                                    <v-icon>{{data.item}}</v-icon>
                                                </template>
                                            </v-select>
                                        </v-col>
                                        <v-col cols="4" md="4">
                                            <v-text-field
                                                    v-model="bullets.title"
                                                    :counter="50"
                                                    maxlength="50"
                                                    label="Title"
                                                    required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4" md="7">
                                            <v-text-field
                                                    v-model="bullets.description"
                                                    :counter="100"
                                                    maxlength="100"
                                                    label="Description"
                                                    required
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
            <br>
            <div v-if="erro">
                <v-alert type="error" dense outlined  v-for="(item,index) in msg" :key="index">
                    {{ item }}
                </v-alert>
            </div>
            <div v-else>
                <v-alert type="success" dense outlined  v-for="(item,index) in msg" :key="index">
                    {{ item }}
                </v-alert>
            </div>
            <v-btn
                    :loading="loading.general"
                    :disabled="!valid"
                    color="success"
                    class="mr-4"
                    @click="validate"
            >
                Save
            </v-btn>
        </v-form>
    </div>
</template>
<script>
    import { VueEditor } from "vue2-editor";
    import {VMoney} from 'v-money'
    import { mask } from 'vue-the-mask';

    export default {
        directives: {
            money: VMoney,
            mask
        },
        components: {
            VueEditor
        },
        data: () => ({
            dataAtual:new Date().toISOString().substr(0, 10),
            dates: [],
            modal: false,
            valid:true,
            loading:{
                general:true,
                condominiums:true,
            },
            dados:{
                name:"",
                en:"",
                pt:"",
                es:"",
                price:"0",
                title:"",
                description:"",
                keywords:"",
                url:"",
                condominium:1,
                status:1,
                bookings:[],
                bullets_en:[
                    {icon:'mdi-home-group',title:'Lorem Ipsum',description:"Cras lorem turpis, tempor id urna rutrum, mattis malesuada orci."},
                    {icon:'mdi-home',title:'Lorem Ipsum',description:"Cras lorem turpis, tempor id urna rutrum, mattis malesuada orci."},
                    {icon:'mdi-spray-bottle',title:'Lorem Ipsum',description:"Cras lorem turpis, tempor id urna rutrum, mattis malesuada orci."},
                    {icon:'mdi-check',title:'Lorem Ipsum',description:"Cras lorem turpis, tempor id urna rutrum, mattis malesuada orci."},
                    {icon:'mdi-check',title:'Lorem Ipsum',description:"Cras lorem turpis, tempor id urna rutrum, mattis malesuada orci."},
                ],
                bullets_es:[
                    {icon:'mdi-home-group',title:'Lorem Ipsum',description:"Cras lorem turpis, tempor id urna rutrum, mattis malesuada orci."},
                    {icon:'mdi-home',title:'Lorem Ipsum',description:"Cras lorem turpis, tempor id urna rutrum, mattis malesuada orci."},
                    {icon:'mdi-spray-bottle',title:'Lorem Ipsum',description:"Cras lorem turpis, tempor id urna rutrum, mattis malesuada orci."},
                    {icon:'mdi-check',title:'Lorem Ipsum',description:"Cras lorem turpis, tempor id urna rutrum, mattis malesuada orci."},
                    {icon:'mdi-check',title:'Lorem Ipsum',description:"Cras lorem turpis, tempor id urna rutrum, mattis malesuada orci."},
                ],
                bullets_pt:[
                    {icon:'mdi-home-group',title:'Lorem Ipsum',description:"Cras lorem turpis, tempor id urna rutrum, mattis malesuada orci."},
                    {icon:'mdi-home',title:'Lorem Ipsum',description:"Cras lorem turpis, tempor id urna rutrum, mattis malesuada orci."},
                    {icon:'mdi-spray-bottle',title:'Lorem Ipsum',description:"Cras lorem turpis, tempor id urna rutrum, mattis malesuada orci."},
                    {icon:'mdi-check',title:'Lorem Ipsum',description:"Cras lorem turpis, tempor id urna rutrum, mattis malesuada orci."},
                    {icon:'mdi-check',title:'Lorem Ipsum',description:"Cras lorem turpis, tempor id urna rutrum, mattis malesuada orci."},
                ]
            },
            condominiums:[],
            file: null,
            imageUrl: [],
            erro:true,
            msg:[],
            language:"en",
            money: {
                decimal: '.',
                thousands: ' ',
                prefix: '$',
                precision: 2,
                masked: false /* doesn't work with directive */
            },
            priceRules: [
                v => !!v || 'Price is required',
                v => (v && v.length <= 200) || 'Price must be less than 200 characters',
            ],
            disabledDates:[],
            breadcrumbs: [
                {
                    text: 'Dashboard',
                    disabled: false,
                    to: '/',
                },
                {
                    text: 'Houses',
                    disabled: false,
                    exact:true,
                    to: '/house',
                },
                {
                    text: 'House Management',
                    disabled: true,
                    to: '/house',
                },
            ],
            panel:0,
            items:[
                "mdi-home-group",
                "mdi-home",
                "mdi-spray-bottle",
                "mdi-calendar-edit",
                "mdi-pencil-ruler",
                "mdi-account-check",
                "mdi-check",
                "mdi-check",
            ]
        }),
        methods: {
            montArrBookings(){
                var iidice = 0;
                var arr = [];
                this.dados.bookings.forEach(function(val){
                    arr[iidice] = val;
                    iidice = iidice+1;
                });
                this.dados.bookings = arr;
            },
            deleteDate(indice){
                var dates = {
                    init:this.dados.bookings[indice].init,
                    end:this.dados.bookings[indice].end,
                };
                const now = new Date(dates.end);
                now.setDate(now.getDate() + 1);
                const past = new Date(dates.init);
                past.setDate(past.getDate() + 1);
                const diff = Math.abs(now.getTime() - past.getTime());
                const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
                this.disabledDates.splice(this.disabledDates.indexOf(dates.init), 1);
                for(var i = 1;i<= days;i++){
                    past.setDate(past.getDate() + 1);
                    var test = past.getFullYear()+'-'+(past.getMonth()+1)+'-'+past.getDate();
                    this.disabledDates.splice(this.disabledDates.indexOf(test), 1);
                }
                this.dados.bookings.splice(indice,1);
                this.montArrBookings();
            },
            saveDate(){
                if(this.dates[0] && this.dates[1]){
                    var dates = {
                        init:this.dates[0],
                        end:this.dates[1],
                    };
                    this.dados.bookings.push(dates);
                    const now = new Date(dates.end);
                    now.setDate(now.getDate() + 1);
                    const past = new Date(dates.init);
                    past.setDate(past.getDate() + 1);
                    const diff = Math.abs(now.getTime() - past.getTime());
                    const days = Math.ceil(diff / (1000 * 60 * 60 * 24));

                    this.disabledDates.push(dates.init);
                    for(var i = 1;i<= days;i++){
                        past.setDate(past.getDate() + 1);
                        var test = past.getFullYear()+'-'+(past.getMonth()+1)+'-'+past.getDate();
                        this.disabledDates.push(test);
                    }
                    this.dates = [];
                    this.modal = false;
                }

            },
            allowedDates(val){
                return !(this.disabledDates.indexOf(val) !== -1);
            },
            onFileChange() {
                var files = this.file;
                if (files) {
                    [].forEach.call(files, this.readAndPreview);
                }
            },
            readAndPreview(file){
                if ( /\.(jpe?g|png|gif|webp)$/i.test(file.name) ) {
                    let reader = new FileReader();
                    reader.onload = () => {
                        this.imageUrl.push({
                            src:reader.result,
                            ordem:(this.imageUrl.length+1),
                            type:file.type
                        });
                    }
                    reader.readAsDataURL(file);
                }else{
                    console.log("Invalid Format");
                }
            },
            montArrImages(){
                var iidice = 0;
                var arr = [];
                this.imageUrl.forEach(function(val){
                    arr[iidice] = val;
                    iidice = iidice+1;
                });
                this.imageUrl = arr;
                for (var i = 0; i < this.imageUrl.length; i++) {
                    this.imageUrl[i].ordem = (i+1);
                }
            },
            sortImage(indice){
                this.imageUrl[indice].ordem = parseInt(this.imageUrl[indice].ordem);
                var newIndice = parseInt((this.imageUrl[indice].ordem-1));
                if(!(newIndice)){
                    newIndice = 0;
                }
                if(newIndice < 0){
                    newIndice = 0;
                }
                //verifico se a nova ordem digitada já pertence a uma chave
                if(this.imageUrl[newIndice]){
                    console.log('1');
                    var arr = this.imageUrl[newIndice];
                    arr.ordem = this.imageUrl[indice].ordem;
                    this.imageUrl[newIndice] = this.imageUrl[indice];
                    this.imageUrl[indice] = arr;
                    this.montArrImages();
                }
                //caso não exista altero a chave da atual para a ordem
                else{
                    console.log('0');
                    this.imageUrl[newIndice] = this.imageUrl[indice];
                    this.deleteImage(indice);
                }
            },
            deleteImage(indice){
                this.imageUrl.splice(indice,1);
                this.montArrImages();
            },
            validate () {
                this.loading.general = true;
                this.erro = false;
                this.dados.image = this.imageUrl;
                this.dados.id = this.$route.params.id;
                var arr = JSON.stringify(this.dados);
                this.$http.post("https://api.bestchoicevacation.com/house/modify",arr,{
                    headers: {
                        'x-access-token': localStorage.hash
                    }
                }).then(response => {
                    this.loading.general = false;
                    this.msg = response.data.msg;
                    if(response.data.erro == '1'){
                        this.erro = true;
                    }else{
                        this.init();
                    }
                });

            },
            init(){
                this.$http.get("https://api.bestchoicevacation.com/house/"+this.$route.params.id,{
                    headers: {
                        'x-access-token': localStorage.hash
                    }
                }).then(response =>{
                    this.loading.general = false;
                    this.dados.name_en = response.data.name_en;
                    this.dados.name_es = response.data.name_es;
                    this.dados.name_pt = response.data.name_pt;

                    this.dados.pt = response.data.pt;
                    this.dados.en = response.data.en;
                    this.dados.es = response.data.es;
                    this.dados.title = response.data.meta_title;
                    this.dados.description = response.data.meta_description;
                    this.dados.keywords = response.data.meta_keywords;
                    this.dados.url = response.data.meta_url;
                    this.dados.status = response.data.status;
                    this.dados.condominium = response.data.condominium;
                    this.dados.bookings = response.data.bookings;
                    this.imageUrl = response.data.images;
                    this.disabledDates = response.data.disabledDates;
                    this.$refs.price.$el.getElementsByTagName('input')[0].value = response.data.price;

                    this.dados.short_description_en = response.data.short_description_en;
                    this.dados.short_description_es = response.data.short_description_es;
                    this.dados.short_description_pt = response.data.short_description_pt;
                    this.dados.guests = response.data.guests;
                    this.dados.bed = response.data.bed;
                    this.dados.rooms = response.data.rooms;
                    this.dados.bath = response.data.bath;

                    this.dados.bullets_en = response.data.bullets_en;
                    this.dados.bullets_es = response.data.bullets_es;
                    this.dados.bullets_pt = response.data.bullets_pt;


                });

                this.$http.get("https://api.bestchoicevacation.com/condominiums/list",{
                    headers: {
                        'x-access-token': localStorage.hash
                    }
                }).then(response =>{
                    this.loading.condominiums = false;
                    for(let i = 0;i<response.data.length;++i){
                        this.condominiums.push({
                            id:response.data[i].id,
                            name:response.data[i].name
                        });
                    }
                });
            },
        },
        mounted(){
            this.init();
        },
        computed: {
            dateRangeText () {
                return this.dates.join(' ~ ')
            },
        },
    }
</script>